import { gql } from "@apollo/client";

import { createNoVarsQueryHandler } from "@/client/graphql/createQueryHandler";
import type { Query } from "@/client/graphql/types/generated";
import { makeSequentialComponent as makeSC } from "@/utils/sequential-component";
import { currentBerthStorage } from "@/utils/storageLocal";
import type { ComponentWithClientIdProps } from "./withClientId";
import { getClientId, withClientId } from "./withClientId";
import { withRouting } from "./withRouting";

export type ComponentWithAuthContextProps = ComponentWithClientIdProps & {
  unloadingDockId: string;
};

const GET_FACTORY_VIEWER = gql`
  query AuthContext_GetFactoryViewer {
    me {
      unloadingDockPattern
      features
    }
  }
`;
const factoryQuery = createNoVarsQueryHandler<{
  me: Pick<Query["me"], "unloadingDockPattern" | "features">;
}>(GET_FACTORY_VIEWER);

/**
 * ログイン状態かつUnloadingDockが選択されているかを確認するHOC
 */
export const withAuthContext = (Component: React.FC<ComponentWithAuthContextProps>) =>
  withClientId(
    makeSC(getCurrentUnloadingDockId)<ComponentWithClientIdProps>(
      Component,
      withRouting("/assessment/berths"),
    ),
  );

const getCurrentUnloadingDockId = () =>
  Promise.resolve()
    .then(() => currentBerthStorage.read())
    .then(async (unloadingDockId) => {
      const clientId = await getClientId();
      const meResult = await factoryQuery();
      if (
        // Linear型の場合は、UnloadingDock選択が無いためエラーにならない
        (unloadingDockId === "" && meResult.me.unloadingDockPattern === "Single") ||
        clientId.clientId === ""
      )
        throw new Error("UnloadingDock not selected");
      return { unloadingDockId: unloadingDockId };
    });
